import { render, staticRenderFns } from "./ISASavePattern.vue?vue&type=template&id=931524d2&scoped=true&"
import script from "./ISASavePattern.vue?vue&type=script&lang=js&"
export * from "./ISASavePattern.vue?vue&type=script&lang=js&"
import style0 from "./ISASavePattern.vue?vue&type=style&index=0&id=931524d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931524d2",
  null
  
)

export default component.exports